import { isBrowser } from "@v2/shared/lib/runtime";
import isLocalStorageAvailable from "src/js/shared/local-storage-helper";
import _getRestApi from "src/js/shared/trello-client/_get-rest-api";
import { Trello } from "types/my-trello-types";

const API_KEY = process.env.API_KEY;
const APP_NAME = process.env.APP_NAME;


// AIDEV-NOTE: This is to be run on the pages consuming the iframe previously initialized in the connector page
export function initTrelloIframeConsumerClient() {
  if (!isBrowser() || !window.TrelloPowerUp?.iframe) {
    throw new Error("TrelloPowerUp iframe API unavailable");
  }

  const options: Trello.PowerUp.PluginOptions =
    isLocalStorageAvailable() && API_KEY && APP_NAME
      ? {
          appKey: API_KEY,
          appName: APP_NAME,
        }
      : {};

  return prepareTrelloClient(window.TrelloPowerUp.iframe(options));
}

// AIDEV-NOTE: hydrate-primary-iframe; attach rest API helper when LS unavailable
function prepareTrelloClient(t: Trello.PowerUp.IFrame) {
  if (!isLocalStorageAvailable() || typeof t.getRestApi !== "function") {
    t.getRestApi = () => _getRestApi(t);
  }
  return t;
}